import Layout from "../../../components/Layout"
import FourOhFour from "../../404"
import BlogPost from "../../../components/contentful/blogPost"
import { getPageContents } from "../../../components/contentful/pageProps"
import { isContentActive } from "../../../components/contentful"

const Post = ({ ...props }) => {
  let {
    content,
    preview,
    breadcrumbs
  } = props

  const isPageActive = content && isContentActive({ ...content, preview })

  if (!isPageActive) return <FourOhFour />

  return (
    <Layout preview={preview} {...props}>
      <BlogPost {...{ content, preview, breadcrumbs }} />
    </Layout>
  )
}

export async function getServerSideProps({ params, ...props }) {
  return await getPageContents(
    {
      ...props,
      breadcrumbs: null,
    },
    {
      type: "blog",
      filterField: "fields.slug[match]",
      filterValue: params.post,
      isIsr: false,
    }
  )
}

export default Post